import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const goToContact = () => {
    setMobileOpen(false);
    navigate('/contacto');
  };

  const goToProjects = () => {
    setMobileOpen(false);
    navigate('/proyectos');
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar__logo" onClick={() => navigate('/')} role="button" aria-label="Volver al inicio">
          <img src="/logo.png" alt="Monologic Solutions Logo" />
          <span className="navbar__logo-text">MONOLOGIC</span>
        </div>

        <ul className="navbar__links">
          <li><button className="navbar__link" onClick={() => scrollTo('servicios')}>Servicios</button></li>
          <li><button className="navbar__link" onClick={() => scrollTo('proceso')}>Proceso</button></li>
          <li><button className="navbar__link" onClick={() => scrollTo('movil')}>Móvil</button></li>
          <li><button className="navbar__link" onClick={goToProjects}>Proyectos</button></li>
          <li><button className="navbar__link" onClick={goToContact}>Contacto</button></li>
        </ul>

        <button className="navbar__hamburger" onClick={() => setMobileOpen(true)} aria-label="Abrir menú de navegación">
          <span /><span /><span />
        </button>

        <button className="navbar__cta" onClick={goToContact}>Iniciar Proyecto</button>
      </nav>

      {/* Mobile menu */}
      <div className={`navbar__mobile-menu ${mobileOpen ? 'open' : ''}`}>
        <button className="navbar__mobile-close" onClick={() => setMobileOpen(false)} aria-label="Cerrar menú de navegación">✕</button>
        <button className="navbar__mobile-link" onClick={() => scrollTo('servicios')}>Servicios</button>
        <button className="navbar__mobile-link" onClick={() => scrollTo('proceso')}>Proceso</button>
        <button className="navbar__mobile-link" onClick={() => scrollTo('movil')}>Móvil</button>
        <button className="navbar__mobile-link" onClick={goToProjects}>Proyectos</button>
        <button className="navbar__mobile-link" onClick={goToContact}>Contacto</button>
      </div>
    </>
  );
};

export default Navbar;
